module.exports = __webpack_public_path__ + "img/open-full-screen.bcff51a6.svg";